module.exports = __webpack_public_path__ + "static/media/instructivoa5.8d21993f.png";